import * as Notifications from 'expo-notifications';

import { fromPromise } from 'xstate';

import type { PushNotificationPermissionStatus } from '../../permissions.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const getPushNotificationPermissionStatusActor =
  fromPromise<PushNotificationPermissionStatus>(async () => Notifications.getPermissionsAsync());
